import { Injectable } from "@angular/core";
import { Item } from "./home.component";

@Injectable()
export class HomeService {

  brandId = 0;
  deviceType: string = '';
  filterGroups: string[] = [];
  
  currentItems: Item[] = [];
  previousItems: Item[] = [];
    
  constructor() {  }
}
